import React from 'react'
import './NavBar.css'
import { Link } from 'react-router-dom'

export default function MobileNav(props) {

    const showMobile = props.showMobile;
    const setShowMobile = props.setShowMobile;

    React.useEffect(() => {
        if (showMobile) {
            document.querySelector('.mobile_nav_menu').style.height = '100%';
        } else {
            document.querySelector('.mobile_nav_menu').style.height = '0';
        }
    }, [showMobile])

    window.addEventListener('click', (e) => {
        if (e.target.closest('.mobile_nav_menu') === null && e.target.closest('.hamburger_icon') === null) {
            setShowMobile(false);
        }
    })

    return (
        <div className="mobile_nav_menu">
            <ul>
                <li>
                    <Link to="/" onClick={() => setShowMobile(false)}>Home</Link>
                </li>
                <li>
                    <Link to="/about" onClick={() => setShowMobile(false)}>About</Link>
                </li>
                {/* <li>
                    <Link to="/events" onClick={() => setShowMobile(false)}>Events</Link>
                </li> */}
                <li>
                    <Link to="/programs" onClick={() => setShowMobile(false)}>Programs</Link>
                </li>
                {/* <li>
                    <Link to="/international" onClick={() => setShowMobile(false)}>International</Link>
                </li> */}
                <li className="highlight-mobile-tab"><a href="https://experience.iitd.ac.in" target="_blank" rel="noopener noreferrer">#ExperienceIITD</a></li>
                <li>
                    <Link to="#">Releases</Link>
                    <div className="dropdown_content">
                        <Link to="/releases/newsletters" onClick={() => setShowMobile(false)}>Newsletters</Link>
                        <Link to="/releases/glimpses" onClick={() => setShowMobile(false)}>Glimpses</Link>
                        <Link to="/releases/podcasts" onClick={() => setShowMobile(false)}>Podcast</Link>
                        {/* <Link to="/releases/tech-reviews" onClick={() => setShowMobile(false)}>Tech Reviews</Link> */}
                    </div>
                </li>
                <li>
                    <Link to="/gallery" onClick={() => setShowMobile(false)}>Gallery</Link>
                </li>
                <li>
                    <Link to="/team" onClick={() => setShowMobile(false)}>Team</Link>
                </li>
                <li>
                    <Link to="/contact" onClick={() => setShowMobile(false)}>Contact</Link>
                </li>
            </ul>
        </div>
    )
}
